import { render, staticRenderFns } from "./preview-task.vue?vue&type=template&id=4c94bfb4&scoped=true"
import script from "./preview-task.vue?vue&type=script&lang=js"
export * from "./preview-task.vue?vue&type=script&lang=js"
import style0 from "./preview-task.vue?vue&type=style&index=0&id=4c94bfb4&lang=scss&scoped=true"
import style1 from "./preview-task.vue?vue&type=style&index=1&id=4c94bfb4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94bfb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c94bfb4')) {
      api.createRecord('4c94bfb4', component.options)
    } else {
      api.reload('4c94bfb4', component.options)
    }
    module.hot.accept("./preview-task.vue?vue&type=template&id=4c94bfb4&scoped=true", function () {
      api.rerender('4c94bfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/preview-task.vue"
export default component.exports